import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { getFormattedDate } from '../../../utils/utilities';
import React from 'react';
import { UserIcon } from '../../../components/users/UserIcon';
import { CopyComponent } from '../../../components/CopyComponent';
import { IUserData } from '../../identyti/identity-interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';

export enum UsersTableAccessorKeys {
	firstName = 'firstName',
	email = 'email',
	twoFactorAuthentication = 'twoFactorEnabled',
	lastLogin = 'lastLogin',
	joinedDate = 'joinedDate',
	group = 'group',
}

export const defaultUsersColumnSizing: ColumnSizing = {
	[UsersTableAccessorKeys.firstName]: 100,
	[UsersTableAccessorKeys.email]: 100,
	[UsersTableAccessorKeys.group]: 70,
	[UsersTableAccessorKeys.twoFactorAuthentication]: 50,
	[UsersTableAccessorKeys.lastLogin]: 50,
	[UsersTableAccessorKeys.joinedDate]: 50,
};

export const defaultUsersColumns: MRT_ColumnDef<IUserData>[] = [
// @ts-ignore
	{
		accessorKey: UsersTableAccessorKeys.firstName,
		header: 'User',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">User</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="d-flex justify-content-start align-items-center fc-text-overflow">
					<div className="w-35px">
						<UserIcon firstName={renderedCellValue} lastName={row?.original?.lastName} />
					</div>
					<div className="ms-4 fs-7 fc-text-overflow">
						{renderedCellValue} {row?.original?.lastName}
					</div>
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: UsersTableAccessorKeys.email,
		header: 'Email',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Email</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="d-flex align-items-center">
					{renderedCellValue && <CopyComponent value={renderedCellValue} title="Email"/>}
					<div className="fs-7 ms-3 fc-text-overflow">
						{renderedCellValue ? renderedCellValue : '-'}
					</div>
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: UsersTableAccessorKeys.group,
		header: 'Role',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Role</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">
					{renderedCellValue?.length ? renderedCellValue[0] : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: UsersTableAccessorKeys.twoFactorAuthentication,
		header: 'Two-factor authentication',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Two-factor authentication</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="d-flex justify-content-center">
					{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: UsersTableAccessorKeys.lastLogin,
		header: 'Last login',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Last login</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{
					renderedCellValue
						? (
							<div className="w-90px">
								<div className="fs-7">
									{getFormattedDate(renderedCellValue, 'dd MMM, yyyy')}
								</div>
								<div className="fs-8">
									{getFormattedDate(renderedCellValue, 'hh:mm a')}
								</div>
							</div>
						) : '-'
				}
			</TableCell>
		)
	},
	{
		accessorKey: UsersTableAccessorKeys.joinedDate,
		header: 'Joined date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Joined date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getFormattedDate(renderedCellValue, 'd MMM, yyyy', undefined)}
			</TableCell>
		)
	},
];
